import { useRouter } from "next/navigation";
import { setIsRedirecting } from "@/store/global/globalSlice";
import { useAppDispatch } from "@/store";

export const useRedirect = () => {
  const router = useRouter();

  const dispatch = useAppDispatch();

  return (url: string) => {
    router.push(url, { scroll: false });
    dispatch(setIsRedirecting(true));
  };
};
